/* Saatchi Watch — product page behaviour. Works with sw.js (cart drawer, quick view, wishlist, rails, reveals). */
(() => {
'use strict';
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
const FINE = matchMedia('(hover:hover) and (pointer:fine)').matches;
const CFG = window.SW || {}, R = CFG.routes || {};
const root = () => { const r = R.root || '/'; return r.endsWith('/') ? r : r + '/'; };
const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const sized = (u, w) => { if (!u) return ''; if (u.startsWith('//')) u = 'https:' + u; return u + (u.includes('?') ? '&' : '?') + 'width=' + w; };
const money = cents => {
  const n = Number(cents) / 100, fmt = CFG.moneyFormat || '${{amount}}';
  return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => { const c = /comma_separator/.test(k), s = n.toFixed(/no_decimals/.test(k) ? 0 : 2).split('.'); s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, c ? '.' : ','); return s.join(c ? ',' : '.'); });
};
const ICON = {
  x: '<svg viewBox="0 0 24 24"><path d="m6 6 12 12M18 6 6 18"/></svg>',
  l: '<svg viewBox="0 0 24 24"><path d="M14 6 8 12l6 6"/></svg>',
  r: '<svg viewBox="0 0 24 24"><path d="m10 6 6 6-6 6"/></svg>'
};
function say(msg) {
  let r = $('#pdpLive');
  if (!r) { r = document.createElement('div'); r.id = 'pdpLive'; r.className = 'sr'; r.setAttribute('aria-live', 'polite'); r.setAttribute('role', 'status'); document.body.appendChild(r); }
  r.textContent = ''; setTimeout(() => { r.textContent = msg; }, 60);
}
function toast(m) { const t = $('#toast'); if (!t) return; $('#toastMsg').textContent = m; t.classList.add('on'); clearTimeout(t._t); t._t = setTimeout(() => t.classList.remove('on'), 2600); }
const kick = el => el && el.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));

/* ---------- gallery ---------- */
function gallery(sec) {
  const g = $('[data-gallery]', sec); if (!g || g._sw) return; g._sw = 1;
  const track = $('[data-track]', g), slides = $$('.g-slide', track), thumbs = $$('.g-thumbs button', g), dots = $$('.g-dots i', g);
  const prev = $('[data-gprev]', g), next = $('[data-gnext]', g), now = $('[data-gnow]', g);
  const grid = () => !!g.closest('.layout-grid') && matchMedia('(min-width: 990px)').matches;
  let cur = 0;
  const set = i => {
    cur = i;
    slides.forEach((s, k) => {
      const on = k === i; s.classList.toggle('is-on', on);
      if (!on) { $$('video', s).forEach(v => v.pause()); $$('.zoomed', s).forEach(z => z.classList.remove('zoomed')); }
    });
    thumbs.forEach((b, k) => b.setAttribute('aria-current', k === i));
    dots.forEach((d, k) => d.classList.toggle('on', k === i));
    if (now) now.textContent = String(i + 1).padStart(2, '0');
    if (prev) prev.disabled = i === 0; if (next) next.disabled = i === slides.length - 1;
    const t = thumbs[i];
    if (t) { const p = t.parentElement; p.scrollTo({ left: t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2, top: t.offsetTop - p.clientHeight / 2 + t.clientHeight / 2, behavior: RM ? 'auto' : 'smooth' }); }
  };
  const go = (i, smooth = true) => {
    i = Math.max(0, Math.min(slides.length - 1, i)); if (!slides[i]) return;
    if (grid()) { if (smooth) slides[i].scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'center' }); set(i); return; }
    track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft * 0, behavior: smooth && !RM ? 'smooth' : 'auto' }); set(i);
  };
  let st;
  track.addEventListener('scroll', () => {
    if (grid()) return; clearTimeout(st);
    st = setTimeout(() => { const w = slides[0].getBoundingClientRect().width || 1, i = Math.round(track.scrollLeft / w); if (i !== cur && slides[i]) set(i); }, 70);
  }, { passive: true });
  prev?.addEventListener('click', () => go(cur - 1));
  next?.addEventListener('click', () => go(cur + 1));
  thumbs.forEach((b, i) => b.addEventListener('click', () => go(i)));
  track.addEventListener('keydown', e => {
    if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
    if (e.key === 'Home') { e.preventDefault(); go(0); }
    if (e.key === 'End') { e.preventDefault(); go(slides.length - 1); }
  });
  const mode = g.dataset.zoom;
  $$('.g-zoom', g).forEach(z => {
    const img = $('img', z);
    if (mode === 'hover' && FINE && img) {
      let loaded = false;
      z.addEventListener('pointerenter', () => {
        if (!loaded && z.dataset.hi) { loaded = true; const pre = new Image(); pre.onload = () => { img.removeAttribute('srcset'); img.src = z.dataset.hi; }; pre.src = z.dataset.hi; }
        z.classList.add('zoomed');
      });
      z.addEventListener('pointermove', e => { const r = z.getBoundingClientRect(); img.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%'); img.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%'); });
      z.addEventListener('pointerleave', () => z.classList.remove('zoomed'));
    }
    if (mode === 'none') { z.style.cursor = 'default'; z.setAttribute('tabindex', '-1'); return; }
    z.addEventListener('click', () => lightbox(g, +z.dataset.lb));
  });
  $('[data-gfs]', g)?.addEventListener('click', () => { const z = $('.g-zoom', slides[cur]); lightbox(g, z ? +z.dataset.lb : 0); });
  g._byMedia = id => { const i = slides.findIndex(s => s.dataset.mediaId === String(id)); if (i > -1 && i !== cur) go(i); };
  const start = +g.dataset.start || 0;
  if (start && !grid()) requestAnimationFrame(() => go(start, false)); else set(start);
  addEventListener('resize', () => { if (!grid()) track.scrollTo({ left: slides[cur].offsetLeft }); }, { passive: true });
}

/* ---------- lightbox ---------- */
let lb;
function lightbox(g, idx) {
  const zs = $$('.g-zoom', g); if (!zs.length) return;
  if (!lb) {
    lb = document.createElement('div'); lb.className = 'lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Image viewer');
    lb.innerHTML = `<div class="lb-track" tabindex="0"></div><p class="lb-count" aria-live="polite"></p><button class="g-btn lb-close" type="button" aria-label="Close image viewer">${ICON.x}</button><button class="g-btn lb-prev" type="button" aria-label="Previous image">${ICON.l}</button><button class="g-btn lb-next" type="button" aria-label="Next image">${ICON.r}</button>`;
    document.body.appendChild(lb);
    const tr = $('.lb-track', lb), cnt = $('.lb-count', lb);
    const at = () => Math.round(tr.scrollLeft / (tr.clientWidth || 1));
    const upd = () => { cnt.textContent = `${String(at() + 1).padStart(2, '0')} / ${String(lb._n).padStart(2, '0')}`; };
    const close = () => { lb.classList.remove('on'); document.body.style.overflow = ''; lb._last?.focus(); };
    tr.addEventListener('scroll', () => { clearTimeout(lb._t); lb._t = setTimeout(upd, 60); }, { passive: true });
    $('.lb-close', lb).addEventListener('click', close);
    $('.lb-prev', lb).addEventListener('click', () => tr.scrollBy({ left: -tr.clientWidth, behavior: RM ? 'auto' : 'smooth' }));
    $('.lb-next', lb).addEventListener('click', () => tr.scrollBy({ left: tr.clientWidth, behavior: RM ? 'auto' : 'smooth' }));
    lb.addEventListener('keydown', e => {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') $('.lb-next', lb).click();
      if (e.key === 'ArrowLeft') $('.lb-prev', lb).click();
      if (e.key === 'Tab') { const f = $$('button, [tabindex="0"]', lb), i = f.indexOf(document.activeElement); e.preventDefault(); f[(i + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus(); }
    });
    lb._upd = upd;
  }
  const tr = $('.lb-track', lb);
  tr.innerHTML = zs.map(z => { const im = $('img', z); return `<figure><img src="${esc(z.dataset.hi || im.currentSrc || im.src)}" alt="${esc(im.alt)}" loading="lazy" decoding="async"></figure>`; }).join('');
  lb._n = zs.length; lb._last = document.activeElement;
  lb.classList.add('on'); document.body.style.overflow = 'hidden';
  requestAnimationFrame(() => { tr.scrollLeft = tr.clientWidth * idx; lb._upd(); $('.lb-close', lb).focus(); });
}

/* ---------- variants (Section Rendering API) ---------- */
function picker(sec) {
  if (sec._pk) return; sec._pk = 1;
  sec.addEventListener('change', e => { if (e.target.closest('[data-picker]') && e.target.matches('input[type="radio"], select')) update(sec, e.target); });
}
async function update(sec, from) {
  const pk = $('[data-picker]', sec); if (!pk) return;
  const ids = [...$$('input[type="radio"]:checked', pk).map(i => i.dataset.ovid), ...$$('select', pk).map(s => s.selectedOptions[0]?.dataset.ovid)].filter(Boolean);
  const focusId = from?.dataset.ovid;
  sec._ctrl?.abort(); sec._ctrl = new AbortController();
  sec.setAttribute('aria-busy', 'true');
  try {
    const res = await fetch(`${sec.dataset.url}?option_values=${ids.join(',')}&section_id=${sec.dataset.section}`, { signal: sec._ctrl.signal });
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const q = $('input[name="quantity"]', sec)?.value;
    $$('[data-swap]', sec).forEach(el => { const n = doc.querySelector(`[data-swap="${el.dataset.swap}"]`); if (n) el.replaceWith(n); });
    const qi = $('input[name="quantity"]', sec); if (qi && q) qi.value = Math.min(+q, +qi.max || Infinity);
    let v = null; try { v = JSON.parse($('[data-swap="vjson"]', sec)?.textContent || 'null'); } catch (e) {}
    apply(sec, v);
    if (focusId) $(`[data-ovid="${focusId}"]`, sec)?.focus({ preventScroll: true });
  } catch (e) { if (e.name !== 'AbortError') console.error(e); }
  finally { sec.removeAttribute('aria-busy'); }
}
function apply(sec, v) {
  const form = document.getElementById(sec.dataset.form), btns = [$('[data-atc]', sec), $('[data-sticky-atc]', sec)].filter(Boolean);
  const label = btns[0]?.dataset.label || 'Add to cart';
  if (!v) { btns.forEach(b => { b.disabled = true; $('.lbl', b).textContent = 'Unavailable'; }); say('This combination is unavailable'); return; }
  const idIn = form && $('input[name="id"]', form);
  if (idIn) { idIn.value = v.id; idIn.dispatchEvent(new Event('change', { bubbles: true })); }
  btns.forEach(b => { b.disabled = !v.available; $('.lbl', b).textContent = v.available ? label : 'Sold out'; });
  history.replaceState(history.state, '', `${sec.dataset.url}?variant=${v.id}`);
  if (v.featured_media) $('[data-gallery]', sec)?._byMedia?.(v.featured_media.id);
  say(`${v.title} selected, ${money(v.price)}${v.available ? '' : ', sold out'}`);
}

/* ---------- quantity ---------- */
function qty(sec) {
  if (sec._qt) return; sec._qt = 1;
  sec.addEventListener('click', e => {
    const b = e.target.closest('[data-qstep]'); if (!b) return;
    const i = b.parentElement.querySelector('input'), step = +i.step || 1, min = +i.min || 1, max = i.max ? +i.max : Infinity;
    const v = Math.max(min, Math.min(max, (+i.value || min) + step * +b.dataset.qstep));
    i.value = v; i.dispatchEvent(new Event('change', { bubbles: true })); sync(i);
  });
  sec.addEventListener('change', e => { if (e.target.name === 'quantity') { const i = e.target, min = +i.min || 1, max = i.max ? +i.max : Infinity; if (!(+i.value >= min)) i.value = min; if (+i.value > max) i.value = max; sync(i); } });
  const sync = i => { const w = i.closest('.p-qty'); if (!w) return; $$('[data-qstep]', w).forEach(b => { b.disabled = +b.dataset.qstep < 0 ? +i.value <= (+i.min || 1) : (i.max && +i.value >= +i.max); }); };
  $$('input[name="quantity"]', sec).forEach(sync);
}

/* ---------- add to cart ---------- */
function atc(sec) {
  const form = document.getElementById(sec.dataset.form); if (!form || form._sw) return; form._sw = 1;
  form.addEventListener('submit', async e => {
    e.preventDefault();
    const btns = [$('[data-atc]', sec), $('[data-sticky-atc]', sec)].filter(Boolean), err = $('[data-atc-err]', sec);
    if (btns[0]?.disabled) return;
    btns.forEach(b => { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });
    if (err) err.textContent = '';
    try {
      const r = await fetch((R.add || '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.description || d.message || 'This item could not be added to your cart.');
      btns.forEach(b => { b.classList.remove('is-loading'); b.classList.add('is-done'); setTimeout(() => b.classList.remove('is-done'), 1800); });
      say(`${d.product_title} added to your cart`);
      document.dispatchEvent(new CustomEvent('sw:cart:added', { detail: d }));
      const cartBtn = $('#btnCart');
      if (cartBtn) setTimeout(() => cartBtn.click(), 450); else toast('Added to cart');
    } catch (x) {
      btns.forEach(b => b.classList.remove('is-loading'));
      if (err) err.textContent = x.message; say(x.message);
    } finally { btns.forEach(b => b.removeAttribute('aria-busy')); }
  });
}

/* ---------- sticky bar ---------- */
function sticky(sec) {
  const bar = $('[data-sticky]', sec), buy = $('[data-buy]', sec); if (!bar || !buy || bar._sw) return; bar._sw = 1;
  let past = false, foot = false;
  const upd = () => { const on = past && !foot; bar.classList.toggle('on', on); bar.setAttribute('aria-hidden', !on); $$('button', bar).forEach(b => { b.tabIndex = on ? 0 : -1; }); };
  new IntersectionObserver(([e]) => { past = !e.isIntersecting && e.boundingClientRect.top < 0; upd(); }).observe(buy);
  const f = $('footer.foot'); if (f) new IntersectionObserver(([e]) => { foot = e.isIntersecting; upd(); }).observe(f);
  $('[data-sticky-atc]', bar)?.addEventListener('click', () => { const form = document.getElementById(sec.dataset.form); form?.requestSubmit ? form.requestSubmit() : form?.dispatchEvent(new Event('submit', { cancelable: true })); });
}

/* ---------- share ---------- */
function share(sec) {
  $$('[data-share]', sec).forEach(b => {
    if (b._sw) return; b._sw = 1;
    b.addEventListener('click', async () => {
      const url = location.origin + sec.dataset.url, title = document.title;
      try {
        if (navigator.share) { await navigator.share({ title, url }); return; }
        await navigator.clipboard.writeText(url); const s = $('span', b), o = s.textContent; s.textContent = 'Link copied'; say('Link copied'); setTimeout(() => { s.textContent = o; }, 2000);
      } catch (e) { /* cancelled */ }
    });
  });
}

/* ---------- recently viewed ---------- */
const RK = 'sw-recent';
const recentList = () => { try { return JSON.parse(localStorage.getItem(RK)) || []; } catch (e) { return []; } };
function remember(h) { if (!h) return; try { localStorage.setItem(RK, JSON.stringify([h, ...recentList().filter(x => x !== h)].slice(0, 16))); } catch (e) {} }
async function recent(el) {
  if (el._sw) return; el._sw = 1;
  const railEl = $('[data-rail]', el), list = recentList().filter(h => h !== el.dataset.current).slice(0, +el.dataset.limit || 8);
  if (!list.length || !railEl) return;
  const got = await Promise.all(list.map(h => fetch(`${root()}products/${encodeURIComponent(h)}.js`).then(r => (r.ok ? r.json() : null)).catch(() => null)));
  const gone = list.filter((h, i) => !got[i]);
  if (gone.length) { try { localStorage.setItem(RK, JSON.stringify(recentList().filter(h => !gone.includes(h)))); } catch (e) {} }
  const ps = got.filter(Boolean); if (!ps.length) return;
  railEl.innerHTML = ps.map(p => {
    const i = p.title.indexOf(' | '), m = i > -1 ? p.title.slice(0, i) : p.title.split(' ')[0], n = i > -1 ? p.title.slice(i + 3) : p.title;
    return `<article class="rc-card"><a class="m" href="${esc(p.url)}" tabindex="-1" aria-hidden="true">${p.featured_image ? `<img src="${esc(sized(p.featured_image, 500))}" alt="" loading="lazy">` : ''}${p.available ? '' : '<span class="bdg so" style="position:absolute;top:12px;left:12px">Sold out</span>'}</a>
      <div class="b"><span class="code">${esc(m)}</span><b><a href="${esc(p.url)}">${esc(n)}</a></b><span class="price">${money(p.price)}</span>
      <button class="link-u" type="button" data-qv="${esc(p.handle)}" style="justify-self:start;margin-top:4px">Quick view</button></div></article>`;
  }).join('');
  el.hidden = false; kick(el);
}

/* ---------- recommendations ---------- */
async function recs(el) {
  if (el._sw || !el.dataset.url) return; el._sw = 1;
  try {
    const doc = new DOMParser().parseFromString(await (await fetch(el.dataset.url)).text(), 'text/html');
    const n = doc.querySelector('[data-recs]');
    if (n && n.querySelector('.pcard')) { el.innerHTML = n.innerHTML; el.hidden = false; kick(el); } else if (!Shopify?.designMode) el.hidden = true;
  } catch (e) { el.hidden = true; }
}

/* ---------- specifications ---------- */
function specs(el) {
  if (el._sw) return; el._sw = 1;
  const tabs = $$('[role="tab"]', el), panels = $$('.sp-panel', el), ind = $('.sp-ind', el), all = $('[data-sp-all]', el);
  const mob = () => matchMedia('(max-width: 760px)').matches;
  const move = t => { if (!ind || !t) return; ind.style.width = t.offsetWidth + 'px'; ind.style.transform = `translateX(${t.offsetLeft}px)`; };
  const sel = (i, focus) => {
    tabs.forEach((t, k) => { t.setAttribute('aria-selected', k === i); t.tabIndex = k === i ? 0 : -1; });
    panels.forEach((p, k) => { p.classList.toggle('off', k !== i); if (!mob()) p.open = true; if (k === i) $$('.sp-row', p).forEach(r => { r.style.animation = 'none'; void r.offsetWidth; r.style.animation = ''; }); });
    move(tabs[i]); if (focus) tabs[i].focus();
  };
  tabs.forEach((t, i) => {
    t.addEventListener('click', () => { el.classList.remove('sp-all-on'); all?.setAttribute('aria-expanded', 'false'); if (all) $('span', all).textContent = all.dataset.more; sel(i); });
    t.addEventListener('keydown', e => { const n = tabs.length; let j = null; if (e.key === 'ArrowRight') j = (i + 1) % n; if (e.key === 'ArrowLeft') j = (i - 1 + n) % n; if (e.key === 'Home') j = 0; if (e.key === 'End') j = n - 1; if (j != null) { e.preventDefault(); tabs[j].click(); tabs[j].focus(); } });
  });
  all?.addEventListener('click', () => { const on = !el.classList.contains('sp-all-on'); el.classList.toggle('sp-all-on', on); all.setAttribute('aria-expanded', on); $('span', all).textContent = on ? all.dataset.less : all.dataset.more; panels.forEach(p => { p.open = true; }); });
  if (mob()) panels.forEach((p, k) => { p.open = k === 0; });
  sel(0);
  addEventListener('resize', () => move(tabs.find(t => t.getAttribute('aria-selected') === 'true')), { passive: true });
}

/* ---------- description read-more ---------- */
function desc(el) {
  const b = $('.desc-body', el), btn = $('[data-more]', el); if (!b || !btn || b._sw) return; b._sw = 1;
  b.classList.add('clamp');
  if (b.scrollHeight <= b.clientHeight + 80) { b.classList.remove('clamp'); return; }
  btn.hidden = false;
  btn.addEventListener('click', () => { const closed = b.classList.toggle('clamp'); btn.setAttribute('aria-expanded', !closed); $('span', btn).textContent = closed ? btn.dataset.more : btn.dataset.less; if (closed) el.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' }); });
}

/* ---------- detail hotspots ---------- */
function details(el) {
  if (el._sw) return; el._sw = 1;
  const all = $$('[data-hs]', el);
  const pick = i => all.forEach(b => { const on = b.dataset.hs === String(i); b.classList.toggle('on', on); if (b.hasAttribute('aria-pressed')) b.setAttribute('aria-pressed', on); });
  all.forEach(b => b.addEventListener('click', () => pick(b.dataset.hs)));
  pick(0);
}

function initAll(r = document) {
  $$('[data-pdp]', r).forEach(sec => {
    if (sec.classList.contains('no-anim') || RM) sec.classList.add('no-anim');
    gallery(sec); picker(sec); qty(sec); atc(sec); sticky(sec); share(sec);
    if (!sec._rv) { sec._rv = 1; remember(sec.dataset.handle); }
  });
  $$('[data-recs]', r).forEach(recs);
  $$('[data-recent]', r).forEach(recent);
  $$('[data-specs]', r).forEach(specs);
  $$('[data-desc]', r).forEach(desc);
  $$('[data-details]', r).forEach(details);
}
document.addEventListener('shopify:section:load', e => initAll(e.target));
document.readyState === 'loading' ? addEventListener('DOMContentLoaded', () => initAll()) : initAll();
})();